export default __webpack_public_path__ + "static/media/symbols.c5900671.svg";